var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.128,23.09632 L20.94528,23.09632 L20.94528,17.97312 C20.94528,16.68608 20.48448,15.808 19.33312,15.808 C18.45376,15.808 17.93024,16.4 17.699904,16.97152 C17.616,17.17632 17.59488,17.4624 17.59488,17.74848 L17.59488,23.09632 L14.41216,23.09632 L14.41216,13.52 L17.59552,13.52 L17.59552,14.9088 C17.59552,14.9088 18.74688,13.29536 20.46336,13.29536 C22.55744,13.29536 24.128,14.66432 24.128,17.60576 L24.128,23.09632 Z M11.0592,12.21248 L11.03872,12.21248 C9.97056,12.21248 9.28,11.47712 9.28,10.55872 C9.28,9.61856 9.99168,8.90368 11.08032,8.90368 C12.1696,8.90368 12.83968,9.61856 12.86016,10.55872 C12.86016,11.47712 12.1696,12.21248 11.0592,12.21248 L11.0592,12.21248 Z M9.468224,23.09632 L12.65088,23.09632 L12.65088,13.52 L9.468224,13.52 L9.468224,23.09632 Z M16,0 C7.16352,0 0,7.16352 0,16 C0,24.83648 7.16352,32 16,32 C24.83648,32 32,24.83648 32,16 C32,7.16352 24.83648,0 16,0 L16,0 Z"
  })));
}

export default __webpack_public_path__ + "static/linkedin-5e369d0b529ae7c04cf2088294298777.svg";
export { SvgLinkedin as ReactComponent };